import moment from 'moment';

export default class ExtensaoDeData  {
    
    static dataEhValida(data) {
        const dataFormatada = moment(data, "DD/MM/YYYY", true);
        return dataFormatada.year() >= 1900 && dataFormatada.isValid();
    }
}